<template>
  <div>
    <vxe-grid
      ref="itemTable"
      auto-resize
      highlight-hover-row
      size="mini"
      :data="tableData"
      :columns="tableColumns"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      :height="333"
      :cell-class-name="'align-top'"
      :edit-rules="validRules"
      @edit-closed="subTotAmount"
      show-footer
      :footer-method="() => footerData"
    >
      <template v-slot:top>
        <div class="side-frame-success">
          <span class="side-frame-text">
            {{ $l('fabric_expense_item') || '费用填报明细' }}
          </span>
          <el-divider direction="vertical" v-if="!disabled"></el-divider>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-success"
            @click="chooseRequestNotes()"
            v-if="!disabled && fabricDisabled"
            ><i class="el-icon-plus" />{{
              $l('btn_choose_request_notes') || '选择申请单'
            }}
          </b-button>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-primary"
            @click="
              () => {
                fabricVisible = true
              }
            "
            v-if="!disabled && !fabricDisabled"
            ><i class="el-icon-plus" />{{
              $l('btn_choose_fabric') || '选择面料'
            }}
          </b-button>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_delete') || '删除'"
          placement="top"
          v-if="!disabled"
        >
          <i class="el-icon-delete tool-btn" @click="delRow(row)"></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('btn_share_expenses') || '分摊费用'"
          placement="top"
          v-if="!disabled && fabricDisabled"
        >
          <i
            class="el-icon-copy-document tool-btn"
            @click="shareExpenses(row)"
          ></i>
        </el-tooltip>
      </template>
      <template v-slot:customer="{ row }">
        <dict-select
          v-model="row.custCode"
          :selectedLabel.sync="row.custName"
          url="/master/common/dict/customerSelect"
          filterable
          clearable
          :disabled="fabricDisabled"
          size="mini"
        ></dict-select>
      </template>
      <template v-slot:custOrderNo="{ row }">
        <OrderSelect
          :orderCode.sync="row.orderCode"
          :custOrderNo.sync="row.custOrderNo"
          :custCode="row.custCode"
          size="mini"
        />
      </template>
      <template v-slot:depCode="{ row }">
        <dep-cascader
          size="mini"
          ref="dep"
          :lastValue.sync="row.depCode"
          :valueString.sync="row.displayDepCode"
          :pathLabels.sync="row.orgDepFullName"
          :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
        />
      </template>
      <template v-slot:fabricInfo="{ row }">
        <span>{{ row.fabricNo }}</span>
        <br />
        <span>{{ row.fabricName }}</span>
        <br />
        <span> {{ row.fabricContent }} </span>
      </template>
      <template v-slot:widAndWeight="{ row }">
        <span>{{ row.wid }} {{ row.widUnit }}</span>
        <br />
        <span>{{ row.fabricWeight }} {{ row.fabricWeightUnit }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
    <ChooseFabricRequestDialog
      :visible.sync="visible"
      :title="
        $l('dialog_title_fabric_request_information') || '面料开发申请信息'
      "
      :scmCode="payeeScmCode"
      :fabricExpenseCode="fabricExpenseCode"
      type="checkbox"
      @confirm="fabricConfirm"
    />

    <ChooseFabric
      :visible.sync="fabricVisible"
      multiple
      @confirm="fabricConfirm"
    />

    <AllocationDialog
      v-if="allocationOption.visible"
      :visible.sync="allocationOption.visible"
      :tableData="allocationOption.tableData"
      :fabricRequestCode="allocationOption.fabricRequestCode"
      :scmCode="payeeScmCode"
      :fabricExpenseCode="fabricExpenseCode"
      @share="shareData"
    />
  </div>
</template>
<script>
import OrderSelect from '@/views/digital/components/order-select'
import requestTableColumns from './table-columns'
import fabricTableColumns from './fabric-table-columns'
import ChooseFabricRequestDialog from '../choose-fabric-request/dialog.vue'
import AllocationDialog from '../allocation-dialog'
import ChooseFabric from '@/views/digital/components/choose-fabric'
import { add, multiplyRound, divideRound, format } from '@/libs/util.number.js'
export default {
  components: {
    OrderSelect,
    ChooseFabricRequestDialog,
    ChooseFabric,
    AllocationDialog,
  },
  props: {
    disabled: { type: Boolean, default: false },
    fabricExpenseCode: { type: String, default: '' },
    depCode: { type: String, default: '' },
    orgDepFullName: { type: String, default: '' },
    payeeScmCode: { type: String, default: '' },
    fabricDisabled: { type: Boolean, default: false },
  },
  data() {
    return {
      visible: false,
      fabricVisible: false,
      tableData: [],
      format: (number) => format(number),
      allocationOption: {
        visible: false,
        fabricRequestCode: '',
        tableData: [],
      },
      validRules: {
        currencyAmount: [
          {
            type: 'number',
            required: true,
            trigger: 'blur',
            pattern: /([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/,
            message:
              this.$l('tips_currency_amount_must_be_greater_than_0') ||
              '费用金额须大于0',
          },
        ],
        requestAmount: [
          {
            type: 'number',
            required: true,
            trigger: 'blur',
            pattern: /([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/,
            message:
              this.$l('tips_fabric_amount_must_be_greater_than_0') ||
              '面料金额须大于0',
          },
        ],
        expenseType: [
          {
            required: true,
            trigger: 'change',
            message:
              this.$l('form_placeholder_expenseType') || '请选择项目费用',
          },
        ],
        custName: [
          {
            required: true,
            trigger: 'change',
            message: this.$l('form_placeholder_custName') || '请选择费用客户',
          },
        ],
        billCount: [
          {
            required: true,
            trigger: 'blur',
            message: this.$l('form_placeholder_billCount') || '请输入单据张数',
          },
        ],
        bizDate: [
          {
            required: true,
            trigger: 'blur',
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
        ],
        fabricColorTitle: [
          {
            required: true,
            trigger: 'blur',
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
        ],
        unitPrice: [
          {
            required: true,
            trigger: 'blur',
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
        ],
        requestQuantity: [
          {
            required: true,
            trigger: 'blur',
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
        ],
        fabricUnit: [
          {
            required: true,
            trigger: 'blur',
            message: this.$l('INDEX.tips_select_data') || '请选择...',
          },
        ],
      },
    }
  },
  computed: {
    tableColumns() {
      return this.fabricDisabled
        ? requestTableColumns(this)
        : fabricTableColumns(this)
    },
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)

      const totalColumnValues = this.tableData.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns
        .filter((c) => c.visible || c.visible === undefined)
        .map((t) => {
          const val = totalColumnValues[t.field]
          return val ? format(val) : ''
        })
      result[this.disabled ? 3 : 4] = '合计'
      return [result]
    },
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      if (!this.fabricExpenseCode) return
      this.$api
        .fabricExpenseItemListApi({ fabricExpenseCode: this.fabricExpenseCode })
        .then((res) => {
          this.tableData = res.body.data
        })
    },
    async chooseRequestNotes() {
      if (!this.payeeScmCode) {
        this.$message({
          showClose: true,
          message:
            this.$l('tips_please_select_the_payeeScmName_first') ||
            '请选择收款供应商',
          type: 'error',
        })
        return
      }
      this.visible = true
    },
    async delRow(row) {
      this.$refs.itemTable.remove(row)
      let index = this.$refs.itemTable.getRowIndex(row)
      this.tableData.splice(index, 1)
      this.updateTotAmount()
    },
    getTableData() {
      const { fullData } = this.$refs.itemTable.getTableData()
      return fullData
    },
    async validate() {
      const $table = this.$refs.itemTable
      //表格校验必填项
      const errMap = await $table.validate(true).catch(() => {
        return true
      })
      if (errMap || !this.fabricDisabled) return !errMap

      //校验供应商是否重复
      const { tableData } = $table.getTableData()
      const index = tableData.findIndex((j) => j.scmCode != this.payeeScmCode)
      if (index !== -1) {
        this.$message.warning(
          '收款供应商 与 费用明细供应商 不一致请检查后保存!'
        )
        return errMap
      } else {
        return !errMap
      }
    },
    subTotAmount({ column = {}, row = {} }) {
      if (column) {
        const { property } = column
        if (property == 'requestAmount') {
          row.unitPrice = divideRound(row.requestAmount, row.requestQuantity, 2)
        }
        if (property == 'requestQuantity' || property == 'unitPrice') {
          row.requestAmount = multiplyRound(
            row.unitPrice,
            row.requestQuantity,
            2
          )
        }
        row.currencyAmount = add(row.requestAmount, row.requestFee)
      }
      this.updateTotAmount()
    },
    updateTotAmount() {
      const totAmount = this.tableData.reduce(
        (result, next) => add(result, next.currencyAmount),
        0
      )
      this.$refs.itemTable.updateFooter()
      this.$emit('updateTotAmount', totAmount)
    },
    fabricConfirm(params) {
      var infos = params
        .map((t) => ({
          expenseType: '',
          billCount: 0,
          currencyAmount: 0,
          depCode: this.depCode,
          orgDepFullName: this.orgDepFullName,
          fabricCode: t.fabricCode,
          fabricRequestCode: t.fabricRequestCode,
          scmCode: t.supCode,
          scmName: t.supName,
          custCode: t.custCode,
          custName: t.custName,
          bizDate: t.requestDate || '',
          fabricNo: t.fabricNo,
          fabricName: t.fabricName,
          fabricContent: t.fabricContent,
          wid: t.wid,
          widUnit: t.widUnit,
          fabricWeight: t.fabricWeight,
          fabricWeightUnit: t.fabricWeightUnit,
          fabricColorTitle: t.fabricColorTitle || '',
          unitPrice: t.unitPrice || 0,
          requestQuantity: t.requestQuantity || 0,
          fabricUnit: t.fabricUnit,
          fabricUnitText: t.v_fabricUnit || t.fabricUnitText,
          requestAmount: t.requestAmount || 0,
          requestFee: t.requestFee || 0,
        }))
        .filter(
          (i) =>
            this.tableData.findIndex((j) =>
              this.fabricDisabled
                ? j.fabricRequestCode === i.fabricRequestCode
                : false
            ) < 0
        )
      infos.push.apply(infos, this.tableData)
      this.tableData = infos

      this.tableData.forEach((t) => {
        t.requestAmount = multiplyRound(t.unitPrice, t.requestQuantity, 2)
        t.currencyAmount = add(t.requestAmount, t.requestFee)
      })
      const totAmount = this.tableData.reduce(
        (result, next) => add(result, next.currencyAmount),
        0
      )
      this.$emit('updateTotAmount', totAmount)
    },
    shareExpenses({ fabricRequestCode }) {
      const groupData = this.tableData.filter(
        (c) => c.fabricRequestCode === fabricRequestCode
      )
      if (!groupData || !groupData.length) return
      this.allocationOption = {
        visible: true,
        fabricRequestCode,
        tableData: groupData,
      }
    },
    shareData(data) {
      const tabData = this.tableData.filter(
        (c) => c.fabricRequestCode != this.allocationOption.fabricRequestCode
      )
      this.tableData = tabData
      data.push.apply(data, this.tableData)
      this.tableData = data
      this.updateTotAmount()
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-cell {
    > div {
      margin-top: 7px;
    }
  }
}
</style>
